
import React from 'react';
import { NavbarContainer } from './NavbarContainer';
import { ContentArea } from './ContentArea';

interface MainContentProps {
  children?: React.ReactNode;
  onMenuClick: () => void;
  isMobile: boolean;
  onToggleSidebar: () => void;
  sidebarCollapsed?: boolean;
}

export const MainContent = ({
  children,
  onMenuClick,
  isMobile,
  onToggleSidebar,
  sidebarCollapsed = false
}: MainContentProps) => {
  // Synchronize margin with sidebar width exactly
  const marginClass = isMobile 
    ? "ml-0" 
    : sidebarCollapsed 
      ? "ml-20" 
      : "ml-64";

  return (
    <div className={`flex flex-col flex-1 w-full transition-all duration-300 ease-in-out ${marginClass}`}>
      <NavbarContainer 
        onMenuClick={onMenuClick} 
        isMobile={isMobile} 
        onToggleSidebar={onToggleSidebar}
      />
      <ContentArea>
        {children}
      </ContentArea>
    </div>
  );
};
